import {
  registerWidgetTaskHandler,
  type WidgetTaskHandlerProps,
} from "react-native-android-widget";
import { buildDuranceWidget } from "./DuranceWidgetView";
import {
  clearWidgetCounterId,
  getWidgetCounterId,
  readCountersSnapshot,
} from "./widget-storage";

async function handler({
  widgetInfo,
  widgetAction,
  renderWidget,
}: WidgetTaskHandlerProps) {
  if (widgetAction === "WIDGET_DELETED") {
    await clearWidgetCounterId(widgetInfo.widgetId);
    return;
  }
  // WIDGET_ADDED / WIDGET_UPDATE / WIDGET_RESIZED / WIDGET_CLICK all just
  // redraw with the currently configured counter — the click itself is
  // handled natively via the "OPEN_APP" clickAction on the widget tile.
  const [counters, counterId] = await Promise.all([
    readCountersSnapshot(),
    getWidgetCounterId(widgetInfo.widgetId),
  ]);
  const counter = counters.find((item) => item.id === counterId) ?? null;
  renderWidget(buildDuranceWidget(counter));
}

export function setupWidgetTaskHandler(): void {
  registerWidgetTaskHandler(handler);
}
